<template>
	<span class="fullscreen_btns">
		<b-button class="btn icon-enlarge ace_sec_txt" type="button" aria-label="Click to full screen window" v-on:click="fullScreenWindow" v-b-tooltip.hover title="Full Screen"></b-button>
		<b-button class="btn icon-shrink ace_sec_txt" type="button" aria-label="Exit full screen" v-on:click="exitFullScreen" v-b-tooltip.hover title="Exit Full Screen"></b-button>
	</span>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'fullScreenMethod',
    props: ['action'],

    methods: {
      ...mapActions([
        'loadLogDashboardActivity'
      ]),

      fullScreenWindow () {
        if (this.action) {
          let courseId = this.$parent.uuid
          let resourceId = this.$parent.entityUuid
          let entityUuid = courseId + '&resourceUuid=' + resourceId
          this.loadLogDashboardActivity({action: this.action, page: 'courseLearn', link: '', entityUuid: entityUuid})
        }
        $('.can_full_screen').addClass('full_screen')
				$('.icon-shrink').focus()
			},

      exitFullScreen () {
        $('.can_full_screen').removeClass('full_screen')
				$('.icon-enlarge').focus()
      }
    }

  }
</script>


<style scoped>
	*:fullscreen
	*:-ms-fullscreen,
	*:-webkit-full-screen,
	*:-moz-full-screen {
	   overflow: auto !important;
	}
</style>



// WEBPACK FOOTER //
// src/app/common/components/fullScreenMethod.vue